var name = {};
module['exports'] = name;
name.man_first_name = require("./man_first_name");
name.woman_first_name = require("./woman_first_name");
name.man_last_name = require("./man_last_name");
name.woman_last_name = require("./woman_last_name");
name.prefix = require("./prefix");
name.suffix = require("./suffix");
name.title = require("./title");
name.name = require("./name");